import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Message from '../Common/Message/Message';
import LandingPoster from './LandingPoster/LandingPoster';
import LandingDetails from './LandingDetails/LandingDetails';
import LandingCalendar from './LandingCalendar/LandingCalendar';
import LandingCast from './LandingCast/LandingCast';
import LandingAd from './LandingAd/LandingAd';
import Share from '../Common/Share/Share';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventLanding.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventLanding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventExists: false,
            activeEvent: {},
            events: [],
            flexpasses: [],
            client: {},
            message: {
                title: '',
                content: '',
                type: ''
            },
            totalClientEvents: []
        };
    }

    componentDidMount() {
        (async () => {
            const params = this.props.routeProps.match.params;
            if(params && params.id) {
                // get active event info
                const activeEventInfoResponse = await this.getActiveEventInfo(params.id);
                console.log('active event info response: ', activeEventInfoResponse);
                if(activeEventInfoResponse.data.event){
                    this.setMessage('','','');
                    let response = activeEventInfoResponse.data.event;
                    let activeEvent = response;

                    this.setState({
                        eventExists: true,
                        activeEvent: activeEvent
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, activeEventInfoResponse.data.error.code,'error');
                }

                // get current client info
                let clientId = this.state.activeEvent.client_id;
                const responseCurrentClient = await this.getCurrentClient(clientId);
                this.props.setGlobalCurrentClient(responseCurrentClient.data.client);
                console.log('Get Current Client: ', responseCurrentClient);
                this.setState({
                    client: responseCurrentClient.data.client || {}
                });

                // get current client events
                const responseEvents = await this.getClientEvents(clientId, this.props.user);
                console.log('Get Events Response: ', responseEvents.data.events);

                // get current client flexpasses
                const responseFlexpass = await this.getClientFlexpass(clientId);
                console.log('Get Flexpass Response: ', responseFlexpass.data.flexpasses);

                if (!responseEvents.data.error && !responseFlexpass.data.error) {
                    this.setMessage('', '', '');
                    this.setState({
                        events: responseEvents.data.events || [],
                        flexpasses: responseFlexpass.data.flexpasses || []
                    });

                    this.setTotalClientEvents();
                } else {
                    this.setMessage(window.general_strings.msg.oops, window.general_strings.msg.somethingWentWrong, 'error');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 3000);
                }
            }
        })();
    }

    getActiveEventInfo = async (eventId) => {
        return await ApiRequest(`/events/public/${eventId}`, {
            method: 'GET'
        });
    };

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    };

    getCurrentClient = async (clientId = '') => {
        let query;
        if (/^\d+$/.test(clientId)) {
            query = `/clients/${clientId}`;
        } else {
            query = `/clients/url-short-name/${clientId}`;
        }
        return await ApiRequest(query);
    };

    getClientEvents = async (clientId, user) => {
        let query;
        user.role ? query = '/events' : query = `/event-listing/${clientId}`;
        return await ApiRequest(query);
    };

    getClientFlexpass = async (clientId = '') => {
        return await ApiRequest(`/flexpass-listing/${clientId}`);
    };

    setTotalClientEvents = () => {
        let activeEvents = [];
        this.state.events.map((event) => {
            if (event.status === "active") {
                activeEvents.push(event);
            }
        });
        this.state.flexpasses.map((flexpass) => {
            if (flexpass.status === "active") {
                activeEvents.push(flexpass);
            }
        });
        this.setState({
            totalClientEvents: activeEvents
        });
    };

    render() {
        let showClientLink = this.state.totalClientEvents.length > 1 && !(this.props.user.role === 'box-office' || this.props.user.role == 'client');
        let shareEvent = {
            details: {
                name: this.state.activeEvent.name,
                event_id: this.state.activeEvent.id
            }
        };
        return (
            <React.Fragment>
                <Share
                    event={shareEvent}
                    iconSize={40}
                />
                {this.state.message.content !== '' &&
                    <div className="showtix-section">
                        <div className="container">
                            <Message
                                message={this.state.message}
                            />
                        </div>
                    </div>
                }
                {this.state.eventExists &&
                <React.Fragment>
                    <div className="showtix-section showtix-background__primary-light">
                        <div className="container">
                            <div className="row mb-4">
                                <div className="col-12 text-center">
                                    <h1 className="showtix-event-landing__title">{ReactHtmlParser(this.state.activeEvent.name)}</h1>
                                    { showClientLink &&
                                    <Link
                                        className="showtix-button showtix-button__medium showtix-background__primary-2"
                                        to={`/events/${this.state.client.id}`}>
                                        See All Events for {ReactHtmlParser(this.state.client.client_name)}
                                    </Link>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 col-md-3 text-center">
                                    <LandingPoster
                                        event={this.state.activeEvent}
                                        strings={strings}
                                        user={this.props.user}
                                    />
                                    <LandingDetails
                                        event={this.state.activeEvent}
                                        client={this.state.client}
                                        strings={strings}
                                    />
                                </div>

                                <div className="col-sm-8 col-md-9">
                                    { this.state.activeEvent.desc && this.state.activeEvent.desc !== "" &&
                                    <div className="showtix-event-landing__description">
                                        {/*<h1>Description</h1>*/}
                                        <p>{ReactHtmlParser(this.state.activeEvent.desc)}</p>
                                    </div>
                                    }

                                    <LandingCalendar
                                        event={this.state.activeEvent}
                                        user={this.props.user}
                                        strings={strings}
                                    />

                                    <LandingCast
                                        event={this.state.activeEvent}
                                        strings={strings}
                                    />
                                    {this.state.activeEvent.ad_graphic_url &&
                                        <div className="showtix-section showtix-background__primary-2 showtix-event__ad">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <LandingAd
                                                            event={this.state.activeEvent}
                                                            strings={strings}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

EventLanding.propTypes = {
    
}

export default EventLanding;


// WEBPACK FOOTER //
// ./src/components/EventLanding/EventLanding.js